'use client'

import Script from 'next/script'
import { useRef } from 'react'
import { useTranslation } from '../../context/ConfigContext'

export default function Suivi() {
  const shipRef = useRef<HTMLDivElement>(null)
  const t = useTranslation()

  return (
    <div className='page-suivi'>
      <h1>{t('Order tracking', {}, true)}</h1>
      <div ref={shipRef}></div>
      <Script
        src='https://cdn.shipup.co/latest_v2/shipup-js.js'
        strategy='lazyOnload'
        onReady={() => {
          /* @ts-ignore */
          const shipup = new ShipupJS.default(process.env.NEXT_PUBLIC_SHIPUP_API_KEY)
          shipup.render(shipRef.current)
        }}
        onError={(e: Error) => {
          // eslint-disable-next-line no-console
          console.error('Script failed: ', e)
        }}
      />
    </div>
  )
}
